/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'credit-card': {
    width: 24,
    height: 24,
    viewBox: '-8 -8 40 40',
    data: '<g><g _stroke="#000"><path pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M13 21.5H5.5a5 5 0 01-5-5v-3.334C.5 7.5 4.5 6.5 6.5 6.5h3c.972 0 2 .5 2 1.5v.5c0 1-1 1.5-2 1.5h-2s-1 3.5-3 3.5"/><path pid="1" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M10.5 15.5H17a1.5 1.5 0 010 3h-4"/><path pid="2" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M10.5 18.5H13a1.5 1.5 0 010 3h-1.5"/><line pid="3" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.5" y1="7.5" x2="11.396" y2="7.5"/><path pid="4" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M5.5 6.578V5A1.5 1.5 0 017 3.5h15A1.5 1.5 0 0123.5 5v9a1.5 1.5 0 01-1.5 1.5H7A1.5 1.5 0 015.5 14v-.812"/><line pid="5" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="21.5" y1="9.5" x2="18.5" y2="9.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/credit-card.js